import { CalendarView } from '@app/components/Calendars/components';
import { useDailyCalendar } from '@app/components/Calendars/DailyCalendar/hooks';
import type { NCalendars } from '@app/components/Calendars/types';

export const DailyCalendar: NCalendars.DailyCalendarType = () => {
  const {
    toPrevDay,
    toNextDay,
    dayNumbers,
    tasks,
    createTaskForRange,
    openPreviewTaskModal,
    isLoading,
  } = useDailyCalendar();
  return (
    <CalendarView
      type="weekly"
      dayHumbers={dayNumbers}
      toPrevDate={toPrevDay}
      toNextDate={toNextDay}
      tasks={tasks}
      createTaskForRange={createTaskForRange}
      openPreviewTaskModal={openPreviewTaskModal}
      isLoading={isLoading}
      className="daily-calendar"
    />
  );
};
